export type State = {
  isLoadingIndicatorVisible: boolean;
  mainMenuOpen: boolean;
  profileMenuOpen: boolean;
  searchOpen: boolean;
  activePanel: { accordionPanel: 'language' | string; active: boolean } | null;
  profileSelectionVisible: boolean;
};

export const state: State = {
  isLoadingIndicatorVisible: false,
  mainMenuOpen: false,
  profileMenuOpen: false,
  searchOpen: false,
  activePanel: null,
  profileSelectionVisible: false,
};
